// src/lang/en.js （英文）
export default {
    menu: {
        home: 'Home',
        about: 'About Us',
        aboutGroup: 'Group Intro',  // Intro = Introduction（常用缩写）
        corporateCulture: 'Brand Culture',  // 无需缩写，简洁明了
        brandHistory: 'Brand History',
        brandPromotion: 'Brand Promotion',
        news: 'Group News',
        productShowcase: 'Group Products',
        teaSeries: 'Tea Series',
        teaDrinkSeries: 'Tea Beverage Series',  // 核心词不可省，否则易混淆
        teaSetSeries: 'Tea Ware Series',
        teaBanquetSeries: 'Tea Banquet Series',
        teaCabinSeries: 'Tea Cabin Series',
        groupControl: 'Group Management',  // 简化："管控"核心是"管理"，省略冗余的 & Control
        jobRecruitment: 'Talent Recruitment',  // 标准表达，无需缩写
        socialResponsibility: 'Social Responsibility',  // 固定术语，不可缩写
        publicWelfare: 'Public Welfare Aid',  // Aid = Assistance（更简洁）
        agricultureView: 'Three Rural Optimal Plan',  // 术语固定，不宜缩写
        villageView: 'Rural Revitalization',  // 简化：省略 Strategy（上下文可推断）
        healthyChina: 'Healthy China Brand',
        contact: 'Contact Us'
    },
    message: {
        langSwitchSuccess: 'Switch language',
        langChinese: 'We have switched to English mode for you',
        // ... 其他提示文本
    },
    products: {
        title: 'Series Products'  // 对应“系列产品”的键
    },
    AboutUsSection: {
        title: 'Building a Century-Old Enterprise, Inheriting Jingchu Culture',
        text: 'Sanpiguang, rooted in the folk traditions of Jingchu, carries a 400-year cultural memory. Legend has it that when Shennong (the Yan Emperor) tasted hundreds of herbs, he discovered that three begonia leaves brewed in a pot would remain unspoiled for seven days—thus earning the name "Sanpiguang". This unique tea-drinking culture is deeply embedded in the land of Jingchu, witnessing the wisdom of life passed down through generations.',
        text2: 'As a brand operator in China\'s big health industry, Sanpiguang Group actively responds to the "Healthy China 2030" strategy and the "Three-Tea Coordination" concept. We deeply integrate tea culture, tea industry, and tea technology. Our mission goes beyond making tea—we are creating a healthy, natural, and sustainable lifestyle, committed to building a tea culture service complex with Jingchu characteristics and a diversified industrial structure.',
        text3: 'With roots in Jingchu and a global vision, the Group has established urban offices in cities including Beijing, Shanghai, Wuhan, Guangzhou, Shenzhen, Chengdu, and Chongqing, and an international hub in Hong Kong. Based on ten-thousand-mu tea gardens and relying on high-quality water sources, we utilize modern tea technology to build key projects such as intelligent super factories, "World Tea Cabins", source tea bases, and natural water bases. We strive to perfectly integrate the millennia-old tea aroma with modern healthy consumption, engaging with the world through Sanpiguang\'s five product lines: tea, water, utensils, time, and space.'
    },
    AboutUsSectionStats: {
        farm: 'Planting Bases',
        factory: 'Super Factories',
        experience: 'Service Experience',
        city: 'Covered Cities',
        unitMu: 'mu', // 亩的英文翻译（或根据需求用 acre 等）
        unitYear: 'years',
        unitPlus: '+'
    },
    brandProText: {
        title: 'Sanpiguang Health', // 品牌名可音译或保留原名
        slogan: 'Nature, Health, Positive Energy',
        description: 'The charm of Sanpiguang lies in its interpretation of the Oriental wisdom of "Great truths are simple" through the simplest ingredients and craftsmanship. Whether it is the simplicity of traditional brewing or the convenience of modern canning, it always centers on "natural, healthy and sweet aftertaste". It not only carries 400 years of cultural memory, but also meets the pursuit of a healthy and quality life for modern people. As Xian Wenliang, general manager of Sanpiguang Group, said: "We are not making beverages, but delivering a lifestyle." This integration of nature, tradition and innovation makes Sanpiguang a "product with stories" worth tasting, collecting and sharing.'
    },
    sectionRenewal: {
        title: '5X Renewed Arrival', // “焕新而来”意译为“焕新登场”，简洁且符合英文表达习惯
        subtitle: 'Inherit Jingchu Culture Create Healthy Life' 
    },
    moreBtn:'Learn More',
    fiveXItems: [
        {
            title: 'Tea',
            relationship: 'Tea Industry',
            icon: 'icon-chaye',
            description: 'The taste symbol of Jingchu culture'
        },
        {
            title: 'Water',
            relationship: 'Tea Drinks',
            icon: 'icon-chayin',
            description: 'A surprise in herbal drinks'
        },
        {
            title: 'Utensils',
            relationship: 'Tea Ware',
            icon: 'icon-chaqi',
            description: 'A jar passed down for a thousand years'
        },
        {
            title: 'Moment',
            relationship: 'Tea Environment',
            icon: 'icon-chajing',
            description: 'The experience highland of Jingchu tea charm'
        },
        {
            title: 'Space',
            relationship: 'Tea World',
            icon: 'icon-chajie',
            description: 'Ecological space matrix'
        }
    ],
    EnterpriseNewsTitle:'Enterprise News',
    ViewDetails:'View details',
    FooterBar:{
        title: 'Service Hotline',
        menuTitle: 'About Us',
        about: 'Group Introduction',
        Culture: 'Brand Culture',
        news: 'News & Updates',
        qxtitle: 'Products',
        chaye: 'Tea Industry',
        chayin: 'Tea Drinks',
        chaqi: 'Tea Ware',
        chayan: 'Tea Banquet',
        chacang: 'Tea Cabin',
        responsibility: 'Responsibility & Public Welfare',
        publicWelfare: 'Public Welfare Activities',
        responsibilityView: 'Social Responsibility',
        Copyright: 'Copyright © Sanpiguang Health Industry Group',
        siteMapView: 'Site Map',
        adminLogin: 'Admin Login',
        ImageUploader: 'Upload Image'
    },
    proCultureImages: {
        culture1: 'https://pic1.imgdb.cn/item/690d8cbf3203f7be00e05dfa.png',
        culture2: 'https://pic1.imgdb.cn/item/690d8cd33203f7be00e05e1c.png',
        culture3: 'https://pic1.imgdb.cn/item/690d8cc03203f7be00e05dfc.png',
        culture4: 'https://pic1.imgdb.cn/item/690d8cbf3203f7be00e05df9.png',
        culture5: 'https://pic1.imgdb.cn/item/690d8cc03203f7be00e05dfb.png'
    }
}
